import MockedSchoolStoreData from './store-data.json'
import MockedPageContentData from './customer-data.json'
import MockedAffiliationData from './affiliation-data.json'
import { errorLogger } from '../api/services';

//! condition to check if all mandatory data is available
if (!window.schoolStoreData || !window.pageContent) {
    errorLogger('Required data is not available on the page.')
}

let AppData = {
    storedata: window.schoolStoreData,
    customerdata: window.pageContent,
    isSchoolStorePage: window.isSchoolStorePage,
    affiliationdata: window.affiliationData
}

if (window.location.hostname === "localhost") {
    AppData = {
        storedata: MockedSchoolStoreData,
        customerdata: MockedPageContentData,
        isSchoolStorePage: true,
        affiliationdata: MockedAffiliationData
    }
}

export { AppData }
